import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { containerMaxWidth, Color, mq } from '../../utils'
import styles from '../Footer/styles.scss'

export const PaidLandingPageFooter = ({ secondaryLinks }: IProps): React.ReactElement => {
  return (
    <div className="footer-wrapper">
      <footer>
        <ul className="secondary-links">
          {secondaryLinks &&
            secondaryLinks.map((link, index) => {
              return (
                <li key={index} className="secondary-list-item">
                  <a href={link.url} className="secondary-link">
                    <Text brand="default" size="body">
                      {link.text}
                    </Text>
                  </a>
                </li>
              )
            })}
        </ul>
      </footer>

      <style jsx>{styles}</style>
      <style jsx>
        {`
          footer {
            max-width: ${containerMaxWidth};
            margin: 0 auto;
          }

          .secondary-links {
            grid-column: content;
            width: 100%;
            margin-left: -12px;
          }

          .secondary-link {
            color: ${Color.Slate};
            text-decoration: none;
            display: block;
            padding: 24px 12px;
          }

          .secondary-link:hover,
          .secondary-link:focus {
            outline: none;
            text-decoration: underline;
          }

          .secondary-list-item {
            display: inline-block;
          }

          @media (${mq.tablet}) {
            footer {
              margin: 0;
            }
          }
          @media (${mq.desktopLg}) {
            footer {
              margin: 0 auto;
            }
          }
        `}
      </style>
    </div>
  )
}
